import { PureComponent, Children, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { node, oneOfType, arrayOf, string } from 'prop-types';

class Portal extends PureComponent {
    constructor(props) {
        super(props);
        this.$wrapper = null;
    }

    componentDidMount() {
        const portalElement = document.querySelector(this.props.wrapper);
        this.$wrapper = portalElement;

        // generate a default portal if there isn't one in the sifu (for nap)
        if (!this.$wrapper && !portalElement) {
            this.$wrapper = document.createElement('div');
            this.$wrapper.id = 'portal-content';
            document.body.appendChild(this.$wrapper);
        }

        this.forceUpdate();
    }

    componentWillUnmount() {
        this.$wrapper = null;
    }

    render() {
        const { children, show, ...rest } = this.props;
        let element;

        if (!this.$wrapper || !show) {
            return null;
        }

        Children.forEach(children, (child) => {
            if (child.key === show) {
                element = cloneElement(child, { ...rest });
            }
        });

        if (!element) {
            return null;
        }

        return createPortal(element, this.$wrapper);
    }
}

Portal.propTypes = {
    show: string,
    wrapper: string,
    children: oneOfType([node, arrayOf(node)]).isRequired,
};

Portal.defaultProps = {
    show: null,
    wrapper: '#portal-content',
};

export default Portal;
